const ORIGIN = 'https://oyun.forin.com.tr';
const TABS = new Set(['active', 'invites', 'finished', 'friends']);
function parseNativeLink(value) {
  if (typeof value !== 'string' || value.length > 256) return null;
  try {
    const url = new URL(value);
    if (url.origin !== ORIGIN || url.protocol !== 'https:' || url.username || url.password || url.hash || url.pathname !== '/open') return null;
    if ([...url.searchParams.keys()].some(key => key !== 'section') || url.searchParams.getAll('section').length !== 1) return null;
    const tab = url.searchParams.get('section');
    return TABS.has(tab) ? { tab } : null;
  } catch { return null; }
}
function createNativeLinkQueue() {
  let pending = null, subscriber = null, last = null, lastAt = 0;
  function dispatch() {
    if (!pending || !subscriber) return;
    const destination = pending; pending = null; subscriber(destination);
  }
  return {
    receive(value) {
      const destination = parseNativeLink(value); if (!destination) return false;
      const now = Date.now();
      if (last === value && now - lastAt < 1500) return false;
      last = value; lastAt = now; pending = destination; dispatch(); return true;
    },
    subscribe(handler) {
      subscriber = handler; dispatch();
      return () => { if (subscriber === handler) subscriber = null; };
    },
  };
}
function connectNativeLinks({ username, token, onOpen }, win = typeof window !== 'undefined' ? window : null) {
  if (!win?.Capacitor?.isNativePlatform?.() || !win.KelimoNative?.links || !username || !token) return () => {};
  return win.KelimoNative.links.subscribe(destination => {
    if (win.sessionStorage.getItem('username')?.toLowerCase() !== username.toLowerCase() || win.sessionStorage.getItem('reconnectToken') !== token) return;
    onOpen(destination);
  });
}
module.exports = { parseNativeLink, createNativeLinkQueue, connectNativeLinks };
